"use client";

import BorderTopCard from "@/app/[locale]/components/cards/BorderTopCard";
import React, { useState } from "react";
import DateCard from "./DateCard";
import DiscktopDatesCards from "./DiscktopDatesCards";
import MobileDatesSlider from "./MobileDatesSlider";
import CalenderIcon from "@/app/[locale]/components/icons/CalenderIcon";
import { CousrsDetailsType } from "@/app/types";
import { useTranslations } from "next-intl";
import Highlighter from "@/app/[locale]/components/typography/Highlighter";
import { colors } from "@/app/config/styles";

function Dates({ course }: DatesCoursePropsType) {
  const [activeDate, setActiveDate] = useState(0);
  console.log(activeDate);
  const t = useTranslations("courses.dates");

  return (
    <div
      className=" py-20 lg:pb-[13rem]"
      style={{
        background: `linear-gradient(0deg, rgba(255,255,255,1) 0%, ${course?.color}20 100%)`,
      }}
    >
      <div className="container relative">
        <CalenderIcon
          color={course?.color}
          className="lg:w-[16rem] w-[8rem] absolute top-[5%] lg:top-[35%] z-0 right-[-4rem] lg:right-0"
        />{" "}
        <h1 className="text-[22px]  font-bold m-auto w-fit lg:text-[3.75rem]">
          {t("title")}
        </h1>
        <p className="text-[12px] pb-20 lg:text-[1.625rem] font-light max-w-[68.5rem] mx-auto leading-[20px] lg:leading-[36px]  text-center">
          <Highlighter
            iKey="courses.dates.description"
            color={colors.secondary}
            variant="underLine"
          />
          
          <span className="border-[#f2e305] border-b-[3px] ">
          </span>{" "}
        </p>
        <div className="relative z-10">
          {" "}
          <div className="md:hidden">
            <MobileDatesSlider course={course} />
          </div>
          <div className="hidden md:block">
            <DiscktopDatesCards course={course} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dates;
type DatesCoursePropsType = {
  course: CousrsDetailsType;
};
